<template>
  <div>
    <!-- primary, success, info, warning, danger, dark, or light. -->
    <b-navbar toggleable="lg" type="dark" variant="success">
      <b-navbar-brand href="#">Cornus Database</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item>
            <router-link to="/home" class="nav-link">
              <b-icon icon="house-fill"></b-icon>
              Home
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/gene" class="nav-link">
              <b-icon icon="flower1"></b-icon>
              Gene
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/blast" class="nav-link">
              <b-icon icon="bar-chart-steps"></b-icon>
              Blast
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/download" class="nav-link">
              <b-icon icon="arrow-down-circle"></b-icon>
              Download
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/about" class="nav-link">
              <b-icon icon="info-square-fill"></b-icon>
              About
            </router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>